angular.module('impactx.catalog').directive('ixMainCatalogData', function ()
{
    return {
        scope: {
            catalog: "=",
            dialogData: "=",
            header: "=",
            requiredLabel: "=",
            onSupplierSelect: "="
        },
        restrict: 'E',
        templateUrl: 'modules/catalog/templates/maincatalogdata.tmpl.html',
        transclude: true
    };
});